import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { IDefaultResponse } from "../../models/DefaultResponse";
import { ICustomerFeature } from "../../models/CustomerFeature/CustomerFeature";
import { CustomerFeatureQueryKeys } from "./keys";

export default function useCustomerFeatures(customerId: string) {
  const { get } = useApiHelper();

  const customerFeatures = useQuery({
    queryKey: CustomerFeatureQueryKeys.all(customerId),
    queryFn: () =>
      get<IDefaultResponse<ICustomerFeature[]>>(
        `/customer/${customerId}/features`,
      ).then((res) => res.data),
  });

  return {
    customerFeatures,
  };
}
